<ndt-compact-register-two-column
  [name]="name"
  [totalCount]="totalCount"
  [callState]="callState"
  [hasNextPage]="hasNextPage"
  [pagingCallState]="pagingCallState"
  [pluralName]="pluralName"
  [showCreate]="departmentPrivileges?.canAdd"
  (create)="onCreate()"
  (quickFilterChange)="onQuickFilterChange($event)"
  (loadMore)="onLoadMore()"
  >
  <ndt-register-quick-filter>
    <mat-slide-toggle
      class="slide-toggle"
      id="toggle-show-all-departments"
      color="primary"
      [ngModel]="includeInactive"
      (ngModelChange)="onShowAllDepartmentsChange($event)"
      >Include Inactive</mat-slide-toggle
      ></ndt-register-quick-filter
      >
      <lcs-responsive-table [columns]="columns">
        <table lcs-table [dataSource]="dataSource">
          <tr lcs-row *lcsResponsiveRowDef></tr>
          <ng-container lcsColumnDef="name" width="4">
            <td
              lcs-cell
              *lcsCellDef="let department"
              [id]="'cell-' + department.departmentId"
              (click)="onDepartmentClick(department.departmentId)"
              class="row-item"
              [ngClass]="{ highlighted: currentSelectedId === department.departmentId }"
              >
              <div class="flex-container">
                <a class="department-overflow-hidden">
                  {{ department.name }}
                </a>
                <div class="context-actions">
                  @if (canDelete() || departmentPrivileges?.canEdit) {
                    <button
                      type="button"
                      mat-button
                      [matMenuTriggerFor]="departmentMenu"
                      [matMenuTriggerData]="{ $implicit: department }"
                      aria-label="Department Actions"
                      matTooltip="More Actions"
                      id="department-detail-more-actions"
                      >
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                  }
                </div>
              </div>
            </td>
          </ng-container>
        </table>
        <mat-menu #departmentMenu="matMenu">
          <ng-template matMenuContent let-department>
            @if (departmentPrivileges?.canEdit && department?.isActive) {
              <button
                mat-menu-item
                type="button"
                (click)="onDeactivateClick(department)"
                id="department-register-deactivate"
                >Deactivate
              </button>
            }
            @if (departmentPrivileges?.canEdit && !department?.isActive) {
              <button
                mat-menu-item
                type="button"
                (click)="onDeactivateClick(department)"
                id="department-register-deactivate"
                >Activate
              </button>
            }
            @if (canDelete()) {
              <button
                mat-menu-item
                type="button"
                (click)="onDeleteClick(department)"
                id="department-delete"
                >
                Delete
              </button>
            }
            @if (departmentPrivileges?.canEdit) {
              <button
                mat-menu-item
                type="button"
                (click)="onUntagClick(department)"
                id="department-register-untag"
                >
                Untag</button
                >
              }
              @if (departmentPrivileges?.canEdit) {
                <button
                  mat-menu-item
                  type="button"
                  (click)="onMergeClick(department)"
                  id="department-register-merge"
                  >Merge</button
                  >
                }
                @if (departmentPrivileges?.canEdit) {
                  <button
                    mat-menu-item
                    type="button"
                    (click)="onRenameClick(department)"
                    id="department-register-rename"
                    >Rename
                  </button>
                }
              </ng-template>
            </mat-menu>
          </lcs-responsive-table>
        </ndt-compact-register-two-column>
